import React from 'react'
import { RaceDTO } from '../../../interfaces/RaceDTO'
import ResultMapCanvas from './ResultMapCanvas';
import './styles/mapstyle.css';

interface Props {
    race: RaceDTO;
}

const ResultMap = ({race}:Props) => {
  return (
    <div>
        <div>Hej</div>
        <ResultMapCanvas />
    </div>
  )
}

export default ResultMap